$(function () {

  $(document).on('click', 'a', function (e) {
    var href = $(this).attr('href');
    if (!href || href === '#') {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  if (lf.data.xhr.client.isLFC) {
    var spinnerSrc = lf.data.xhr.assetsPath + '/legacy-assets/img/spinner-green-48x48.gif';
    var $pageLoadingOverlay = $('<div id="lfc-page-loading-overlay"></div>');
    var $spinner = $('<img class="lfc-page-loading-overlay__spinner" src="' + spinnerSrc + '" />');
    
    $pageLoadingOverlay
      .append($spinner)
      .hide()
      .appendTo('body');

    $(window).on('beforeunload', function (e) {
      $pageLoadingOverlay.show();
    });
    
    $(window).on('unload', function () {
      $('#lfc-page-loading-overlay').remove();
    });
  }
  
});
